import { render, staticRenderFns } from "./uploadFilePreview.vue?vue&type=template&id=23c929fa&scoped=true&"
import script from "./uploadFilePreview.vue?vue&type=script&lang=js&"
export * from "./uploadFilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c929fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
